import { useConfigCatClient, useFeatureFlag } from 'configcat-react';
import { useFlagsContext } from '../GovernanceProvider';

export const useFlag = (flagKey: string): boolean => {
  const configCatClient = useConfigCatClient();
  const { flagsReady } = useFlagsContext();
  const defaultValue = flagsReady ? configCatClient.snapshot().getValue(flagKey, false) : false;
  const { value: configCatValue } = useFeatureFlag(flagKey, defaultValue);

  return configCatValue;
};

export const useFlagsStatus = (): { flagsReady: boolean; flagsError: boolean } => {
  const { flagsReady, flagsError } = useFlagsContext();

  return { flagsReady, flagsError };
};
